/**
 * @generated SignedSource<<b47e4cbe1547804674755abba7ac7d9d>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type salesChannelSwitchTasksQuery$variables = Record<PropertyKey, never>;
export type salesChannelSwitchTasksQuery$data = {
  readonly productSwitcherTasks: ReadonlyArray<{
    readonly createdOn: string;
    readonly elapsedTime: number;
    readonly errorCount: number;
    readonly extraData: {
      readonly areOrdersSalesChannelsSwitched: boolean;
      readonly areProductMultipleVariantsRulesAttributesSwitched: boolean;
      readonly areSalesChannelDetailsSwitched: boolean;
      readonly areSwitchedProductCodes: boolean;
      readonly areSwitchedSCApiKeys: boolean;
      readonly areSwitchedSCEcommerceSettings: boolean;
      readonly errors: {
        readonly orderIDs: ReadonlyArray<number> | null;
        readonly productIDs: ReadonlyArray<number> | null;
      } | null;
      readonly masterSalesChannelID: number;
      readonly secondarySalesChannelID: number;
      readonly sellerID: number;
      readonly switchedProducts: ReadonlyArray<number> | null;
      readonly taskID: number;
    };
    readonly lastError: string;
    readonly modifiedOn: string;
    readonly state: number;
    readonly taskID: number;
    readonly taskType: string;
  }> | null;
};
export type salesChannelSwitchTasksQuery = {
  response: salesChannelSwitchTasksQuery$data;
  variables: salesChannelSwitchTasksQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "taskID",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "taskType",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "state",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdOn",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "modifiedOn",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "errorCount",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastError",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "elapsedTime",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "concreteType": "ProductSwitcherTaskExtraData",
  "kind": "LinkedField",
  "name": "extraData",
  "plural": false,
  "selections": [
    (v0/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "sellerID",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "masterSalesChannelID",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "secondarySalesChannelID",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "areSwitchedSCApiKeys",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "areSwitchedSCEcommerceSettings",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "areSwitchedProductCodes",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "switchedProducts",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "areSalesChannelDetailsSwitched",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "areProductMultipleVariantsRulesAttributesSwitched",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "areOrdersSalesChannelsSwitched",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ProductSwitcherTaskErrors",
      "kind": "LinkedField",
      "name": "errors",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "productIDs",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "orderIDs",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "salesChannelSwitchTasksQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ProductSwitcherTask",
        "kind": "LinkedField",
        "name": "productSwitcherTasks",
        "plural": true,
        "selections": [
          (v0/*:: as any*/),
          (v1/*:: as any*/),
          (v2/*:: as any*/),
          (v3/*:: as any*/),
          (v4/*:: as any*/),
          (v5/*:: as any*/),
          (v6/*:: as any*/),
          (v7/*:: as any*/),
          (v8/*:: as any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "salesChannelSwitchTasksQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ProductSwitcherTask",
        "kind": "LinkedField",
        "name": "productSwitcherTasks",
        "plural": true,
        "selections": [
          (v0/*:: as any*/),
          (v1/*:: as any*/),
          (v2/*:: as any*/),
          (v3/*:: as any*/),
          (v4/*:: as any*/),
          (v5/*:: as any*/),
          (v6/*:: as any*/),
          (v7/*:: as any*/),
          (v8/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "c07fda623ef420c09aec978f34855268",
    "id": null,
    "metadata": {},
    "name": "salesChannelSwitchTasksQuery",
    "operationKind": "query",
    "text": "query salesChannelSwitchTasksQuery {\n  productSwitcherTasks {\n    taskID\n    taskType\n    state\n    createdOn\n    modifiedOn\n    errorCount\n    lastError\n    elapsedTime\n    extraData {\n      taskID\n      sellerID\n      masterSalesChannelID\n      secondarySalesChannelID\n      areSwitchedSCApiKeys\n      areSwitchedSCEcommerceSettings\n      areSwitchedProductCodes\n      switchedProducts\n      areSalesChannelDetailsSwitched\n      areProductMultipleVariantsRulesAttributesSwitched\n      areOrdersSalesChannelsSwitched\n      errors {\n        productIDs\n        orderIDs\n      }\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "778bd424864322a6a0a6387a02670ffd";

export default node;
